import { render, staticRenderFns } from "./bill.vue?vue&type=template&id=5a500cb1&scoped=true"
import script from "./bill.vue?vue&type=script&lang=js"
export * from "./bill.vue?vue&type=script&lang=js"
import style0 from "./bill.vue?vue&type=style&index=0&id=5a500cb1&prod&scoped=true&lang=css"
import style1 from "./bill.vue?vue&type=style&index=1&id=5a500cb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a500cb1",
  null
  
)

export default component.exports